import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateRefundAction as updateRefund } from '../../../../../services/RefundService/slice';

export const EscalateSwitch: React.FC = () => {
    const dispatch = useAppDispatch();
    const { currentRefund } = useAppSelector(state => state.refund);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const priority = event.target.checked ? 'High' : 'Standard';
        dispatch(updateRefund({ priority }));
    };

    return (
        <FormControlLabel
            control={
                <Switch
                    checked={currentRefund?.priority === 'High'}
                    onChange={handleChange}
                    size="small"
                />
            }
            label="Escalate"
        />
    );
};

export default EscalateSwitch;
